module.exports = __webpack_public_path__ + "static/media/Logo.60580d0a.gif";